
<template>
  <!--  <el-dialog :visible.sync="dialogVisible"  @close="handleClose">-->
  <div class="dialog" v-loading="loading">
    <el-form ref="formData"  v-model="formData" label-width="200px" >
      <el-form-item label="DI码：" class="half" >
        <span>{{formData.di}}</span>
      </el-form-item>
      <el-form-item label="ERP编码：" class="half">
        <span>{{formData.erp_id}}</span>
      </el-form-item>
      <el-form-item label="产品名称：" class="half">
        <span>{{formData.reagent_name}}</span>
      </el-form-item>
      <el-form-item label="包装规格：" class="half">
        <span>{{formData.standard}}</span>
      </el-form-item>
      <el-form-item label="产品分类：" class="half">
        <span>{{formData.product_categories}}</span>
      </el-form-item>
      <el-form-item label="品牌名称：" class="half">
        <span>{{formData.brand_name}}</span>
      </el-form-item>
      <el-form-item label="RFID标识：" class="half">
        <span>{{formData.rfid}}</span>
      </el-form-item>
      <el-form-item label="RFID标识备注：" class="half"  prop="total_questions">
        <span>{{formData.rfid_remarks}}</span>
      </el-form-item>
      <el-form-item label="医疗器械或药品注册证编号：" class="half"  prop="total_questions">
        <span>{{formData.commodity}}</span>
      </el-form-item>
      <el-form-item label="关键字：" class="half">
        <span>{{formData.reagent_keywords}}</span>
      </el-form-item>
      <el-form-item label="备注：" class="half">
        <span>{{formData.note}}</span>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {getExamDtl, getTrainOptions} from "@/api/training";
export default {
  name: "checkDialog",
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      form:{},
      dialogVisible: false,
    };
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-form-item{
  display: inline-block;
  .el-form-item__label{
    font-weight: bold;
  }
}
.half{
  width: 50%;
}
.dialog{
  padding: 0 20px!important;
}
</style>